import React from "react";

const HomeConstruction = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff',
      color: '#222',
      fontFamily: "'Inter', sans-serif",
      textAlign: 'center',
      padding: '20px'
    }}>
      <img
        src="/images/logofav.png"
        alt="DOMOELEC"
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'contain',
          marginBottom: '24px'
        }}
      />

      <h1 style={{
        fontSize: '1.4rem',
        fontWeight: 600,
        margin: '0 0 8px 0',
        letterSpacing: '2px'
      }}>
        DOMOELEC
      </h1>

      <p style={{
        fontSize: '0.95rem',
        color: '#666',
        marginBottom: '32px'
      }}>
        Sp&eacute;cialiste du courant faible
      </p>

      <p style={{
        fontSize: '1rem',
        color: '#333',
        marginBottom: '8px',
        fontWeight: 500
      }}>
        Site en construction
      </p>

      <p style={{
        fontSize: '0.9rem',
        color: '#888',
        maxWidth: '400px',
        lineHeight: 1.6
      }}>
        Notre site sera bient&ocirc;t disponible.
      </p>

      <div style={{
        marginTop: '40px',
        display: 'flex',
        gap: '24px',
        flexWrap: 'wrap',
        justifyContent: 'center',
        fontSize: '0.9rem',
        color: '#555'
      }}>
        <a href="tel:+212522340659" style={{ color: '#555', textDecoration: 'none' }}>
          05 22 34 06 59
        </a>
        <a href="mailto:contact@domoelec.ma" style={{ color: '#555', textDecoration: 'none' }}>
          contact@domoelec.ma
        </a>
      </div>
    </div>
  );
};

export default HomeConstruction;
